"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PropsProvider;
function PropsProvider() {
  return function (context, funcDetails, payload) {
    context.props = payload || {};

    return context;
  };
}
//# sourceMappingURL=Props.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/function-tree/lib/providers/Props.js
// module id = 713
// module chunks = 0